module.exports = __webpack_public_path__ + "static/img/roche.2b24014.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/roche.png
// module id = ZKcH
// module chunks = 0